import api from '@/api/Api'
import store from '../store'
import config from '@/config'
export const state = {
  notifications: [],
  countNew: undefined
}

export const getters = {
  notifications(state) {
    return state.notifications
  },
  countNew(state) {
    return state.countNew
  }
}

export const mutations = {
  SET_NOTIFICATION(state, newValue) {
    state.notifications = newValue
    let unread = newValue.filter(val => val.status === -1)
    state.countNew = unread.length === 0 ? undefined : unread.length
    document.title = state.countNew > 0 ? `(${state.countNew})  ${config.title}` : config.title
  }
}
let channel
export const actions = {
  init({ state, dispatch, rootState }) {
    // setInterval(_ => {
    //   dispatch('fetchNotification')
    // }, 10000)
  },
  afterAuthSocket({ dispatch, rootState, rootGetters }) {
    if (channel) {
      channel.unsubscribe()
    }
    if (rootGetters['auth/loggedIn']) {
      let userId = rootState.auth.currentUser.id
      channel = window.Echo.private(`user.${userId}`)
        .listen('NewNotification', e => {
          dispatch('fetchNotification')
        })
        .listen('UserEOTokenChange', e => {
          store.commit('auth/UPDATE_TOTAL_TOKEN', e.token_amount)
        })
    }
  },
  async fetchNotification({ commit }) {
    const res = await api.getNotifications()
    if (res) {
      let noti = res.data.data
      commit('SET_NOTIFICATION', noti)
      return res.data
    }
  },

  markRead({ commit, state, dispatch }, item) {
    return api.readNotification(item.id).then(response => {
      dispatch('fetchNotification')
      return response.data
    })
  },

  seeAll({ commit, state, dispatch }) {
    return api.seeNotification().then(response => {
      dispatch('fetchNotification')
      return response.data
    })
  },
  readAll({ commit, state, dispatch }) {
    return api.readAllNotification().then(response => {
      dispatch('fetchNotification')
      return response.data
    })
  }
}



// WEBPACK FOOTER //
// ./src/state/modules/notification.js